(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cryela-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initSlider(el) {
      var viewport = el.querySelector('.cs__viewport');
      var track    = el.querySelector('.cs__track');
      var slides   = Array.from(el.querySelectorAll('.cs__slide'));
      var dots     = Array.from(el.querySelectorAll('.cs__dot'));
      var prevBtn  = el.querySelector('.cs__arrow--p');
      var nextBtn  = el.querySelector('.cs__arrow--n');
      var total    = slides.length;

      if (total < 2) return;

      var current     = 0;
      var timer       = null;
      var isAnimating = false;
      var autoplay    = el.dataset.autoplay === 'true';
      var speed       = parseInt(el.dataset.speed,  10) || 4500;
      var animMs      = parseInt(el.dataset.anim,   10) || 700;
      var pauseHover  = el.dataset.pause === 'true';
      var touchStartX = 0;

      track.style.transition = 'transform ' + animMs + 'ms cubic-bezier(0.4,0,0.2,1)';

      function vw() { return viewport.offsetWidth; }

      function setPos(idx, instant) {
        if (instant) {
          track.style.transition = 'none';
          track.style.transform  = 'translateX(-' + (idx * vw()) + 'px)';
          requestAnimationFrame(function () {
            track.style.transition = 'transform ' + animMs + 'ms cubic-bezier(0.4,0,0.2,1)';
          });
        } else {
          track.style.transform = 'translateX(-' + (idx * vw()) + 'px)';
        }
      }

      function goTo(idx) {
        if (isAnimating) return;
        isAnimating = true;

        slides[current].classList.remove('is-active');
        if (dots[current]) {
          dots[current].classList.remove('is-on');
          dots[current].setAttribute('aria-selected', 'false');
        }

        current = ((idx % total) + total) % total;
        setPos(current, false);

        slides[current].classList.add('is-active');
        if (dots[current]) {
          dots[current].classList.add('is-on');
          dots[current].setAttribute('aria-selected', 'true');
        }

        setTimeout(function () { isAnimating = false; }, animMs);
      }

      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      function startAuto() {
        if (!autoplay) return;
        clearInterval(timer);
        timer = setInterval(next, speed);
      }

      function stopAuto() {
        clearInterval(timer);
        timer = null;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { stopAuto(); prev(); startAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { stopAuto(); next(); startAuto(); });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { stopAuto(); goTo(i); startAuto(); });
      });

      if (pauseHover) {
        el.addEventListener('mouseenter', stopAuto);
        el.addEventListener('mouseleave', startAuto);
      }

      el.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      el.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 48) {
          stopAuto();
          if (diff > 0) next(); else prev();
          startAuto();
        }
      }, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { setPos(current, true); }, 120);
      });

      startAuto();
    }

    function boot() {
      document.querySelectorAll('[data-cryela-slider]').forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cryela-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroSlider(root) {
      if (root.dataset.sliderReady === 'true') return;
      root.dataset.sliderReady = 'true';

      var track = root.querySelector('.cryela-hero__track');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.cryela-hero__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.cryela-hero__dot'));
      var prev = root.querySelector('.cryela-hero__arrow--prev');
      var next = root.querySelector('.cryela-hero__arrow--next');
      var total = slides.length;
      var current = 0;
      var position = 1;
      var animating = false;
      var timer = null;
      var touchStartX = 0;
      var autoplay = root.dataset.autoplay === 'true';
      var speed = parseInt(root.dataset.speed, 10) || 4500;
      var pauseOnHover = root.dataset.pause === 'true';

      if (!track || total < 2) return;

      slides.forEach(function (slide, index) {
        slide.dataset.realIndex = String(index);
      });

      var firstClone = slides[0].cloneNode(true);
      var lastClone = slides[total - 1].cloneNode(true);
      firstClone.dataset.realIndex = '0';
      lastClone.dataset.realIndex = String(total - 1);
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      track.appendChild(firstClone);
      track.insertBefore(lastClone, slides[0]);

      var allSlides = Array.prototype.slice.call(track.querySelectorAll('.cryela-hero__slide'));

      function setTransition(enabled) {
        track.style.transition = enabled ? 'transform 650ms cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      }

      function setPosition(nextPosition, instant) {
        position = nextPosition;

        if (instant) {
          setTransition(false);
        }

        track.style.transform = 'translateX(-' + (position * 100) + '%)';

        if (instant) {
          track.offsetHeight;
          requestAnimationFrame(function () {
            setTransition(true);
          });
        }
      }

      function syncState() {
        allSlides.forEach(function (slide, physicalIndex) {
          var realIndex = parseInt(slide.dataset.realIndex, 10);
          var isCurrentRealSlide = realIndex === current;
          var isCurrentPhysicalSlide = physicalIndex === position;

          slide.classList.toggle('is-active', isCurrentRealSlide);
          slide.setAttribute('aria-hidden', isCurrentPhysicalSlide ? 'false' : 'true');

          Array.prototype.slice.call(slide.querySelectorAll('a, button, input, select, textarea')).forEach(function (item) {
            if (isCurrentPhysicalSlide) {
              item.removeAttribute('tabindex');
            } else {
              item.setAttribute('tabindex', '-1');
            }
          });
        });

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
          dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
      }

      function goTo(index) {
        if (animating) return;

        if (index === current) {
          return;
        }

        animating = true;
        current = (index + total) % total;
        setPosition(index + 1, false);
        syncState();
      }

      function start() {
        if (!autoplay) return;
        window.clearInterval(timer);
        timer = window.setInterval(function () {
          goTo(current + 1);
        }, speed);
      }

      function stop() {
        window.clearInterval(timer);
        timer = null;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          stop();
          goTo(current - 1);
          start();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          stop();
          goTo(current + 1);
          start();
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          stop();
          goTo(index);
          start();
        });
      });

      root.addEventListener('touchstart', function (event) {
        touchStartX = event.touches[0].clientX;
      }, { passive: true });

      root.addEventListener('touchend', function (event) {
        var diff = touchStartX - event.changedTouches[0].clientX;
        if (Math.abs(diff) > 45) {
          stop();
          goTo(diff > 0 ? current + 1 : current - 1);
          start();
        }
      }, { passive: true });

      if (pauseOnHover) {
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
      }

      track.addEventListener('transitionend', function (event) {
        if (event.target !== track || event.propertyName !== 'transform') return;

        if (position === total + 1) {
          setPosition(1, true);
        } else if (position === 0) {
          setPosition(total, true);
        }

        animating = false;
        syncState();
      });

      setPosition(1, true);
      syncState();
      start();
    }

    function boot() {
      document.querySelectorAll('[data-cryela-hero-slider]').forEach(initHeroSlider);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var slider = event.target.querySelector('[data-cryela-hero-slider]');
      if (slider) initHeroSlider(slider);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cryela-loved-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function shuffle(items) {
      for (var i = items.length - 1; i > 0; i -= 1) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = items[i];
        items[i] = items[j];
        items[j] = tmp;
      }
      return items;
    }

    function initLovedProducts(root) {
      if (root.dataset.lovedReady === 'true') return;
      root.dataset.lovedReady = 'true';

      var grid = root.querySelector('.cryela-loved__grid');
      if (!grid) return;

      var cards = Array.prototype.slice.call(grid.querySelectorAll('.cryela-loved__card'));
      var limit = parseInt(root.dataset.limit, 10) || cards.length;
      var shouldRandomize = root.dataset.randomize === 'true';

      if (shouldRandomize) {
        shuffle(cards).forEach(function (card) {
          grid.appendChild(card);
        });
      }

      cards = Array.prototype.slice.call(grid.querySelectorAll('.cryela-loved__card'));
      cards.forEach(function (card, index) {
        card.hidden = index >= limit;
      });
    }

    function boot() {
      document.querySelectorAll('[data-cryela-loved-products]').forEach(initLovedProducts);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-cryela-loved-products]');
      if (section) initLovedProducts(section);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-cryela-product-filter]');
    if (!form) return;

    window.clearTimeout(form._cryelaSubmitTimer);
    form._cryelaSubmitTimer = window.setTimeout(() => form.requestSubmit(), 120);
  });

  document.addEventListener('toggle', (event) => {
    const openedGroup = event.target;
    if (!openedGroup.matches('.cryela-filter-group[open]')) return;

    const form = openedGroup.closest('[data-cryela-product-filter]');
    if (!form) return;

    form.querySelectorAll('.cryela-filter-group[open]').forEach((group) => {
      if (group !== openedGroup) group.removeAttribute('open');
    });
  }, true);

  document.addEventListener('click', (event) => {
    const form = event.target.closest('[data-cryela-product-filter]');
    const toggle = event.target.closest('[data-cryela-filter-toggle]');
    const close = event.target.closest('[data-cryela-filter-close]');

    if (toggle) {
      const currentForm = toggle.closest('[data-cryela-product-filter]');
      currentForm?.classList.add('is-mobile-open');
      document.documentElement.classList.add('cryela-filter-open');
      return;
    }

    if (close) {
      const currentForm = close.closest('[data-cryela-product-filter]');
      currentForm?.classList.remove('is-mobile-open');
      document.documentElement.classList.remove('cryela-filter-open');
      return;
    }

    if (form && form.classList.contains('is-mobile-open') && event.target === form) {
      form.classList.remove('is-mobile-open');
      document.documentElement.classList.remove('cryela-filter-open');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
